function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-69,-67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "matrix(1.61997,0,0,1.61997,-45.6389,52.6294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54324,0,0,1.54324,70.994,10.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.383,4.318C18.009,4.163 17.579,4.249 17.293,4.535C16.029,5.798 13.972,5.799 12.707,4.535C10.662,2.492 7.337,2.492 5.293,4.535C5.105,4.722 5,4.977 5,5.242L5,18.242C5,18.794 5.447,19.242 6,19.242C6.553,19.242 7,18.794 7,18.242L7,13.689C8.271,12.692 10.121,12.778 11.293,13.949C13.338,15.992 16.664,15.992 18.707,13.949C18.895,13.761 19,13.507 19,13.242L19,5.242C19,4.837 18.756,4.473 18.383,4.318Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.3cb5dda9.svg";
export { ForwardRef as ReactComponent };